import React from 'react';
import './CustomersNoticeTip.css';

/** Tooltip moderno (substitui title/alt nativo) — light/dark + seta por placement. */
export default function CustomersNoticeTip({
  label,
  placement = 'top',
  children,
  className = '',
  wrap = false,
  disabled = false,
}) {
  const text = String(label || '').trim();
  if (!text || disabled) return children;
  const shouldWrap = wrap || text.length > 48;
  return (
    <span
      className={[
        'cmc-notice-tip-host',
        `cmc-notice-tip-host--${placement}`,
        shouldWrap ? 'cmc-notice-tip-host--wrap' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      data-tooltip={text}
    >
      {children}
    </span>
  );
}
